import type {BrandContent} from "@Components/mystuff-brands/brand-kits.types";
import {useAppSelector} from "@/hooks";

export const useBrandContentMap = (): BrandContent => {
    return useAppSelector(({brands}) => {
        return brands.brandContent as BrandContent;
    });
}